import { Component, OnInit } from '@angular/core';
import { ExternalUserService } from '@externaluserservice/external-user.service';
import { Routes, RouterModule, ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TransactionHistory, TransactionHistoryUpdate } from '@externalusermodel/Order';
import { ChaseUIDRequest } from '@externalusermodel/AdvancePayment';
import { ChaseProfileTransactionData } from '@externalusermodel/ChaseProfileTransactionData';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.css'],
  providers: [ExternalUserService]
})
export class OrderDetailsComponent implements OnInit {

  Ordertotalamount: number;
  selectedOrderIDs: string;
  OderagencyName: string;
  isPayment: boolean;
  orderDetail: any= [];
  actualAmount: number;
  InvalidAmount: boolean;
  InvalidAmount2: boolean;
  OrderagencyID: string;
  isSelectedMultipleOrder: boolean;
  isChecked: boolean;

  displayAddRefundPopUp: boolean;
  UserID: any;

  response_data: string;
  methodName: string;
  AmountpayingACH: string;
  AmountpayingCC: string;

  count: any;

  chaseOrderId: string;
  private sub: any;

  uIDRequestData: ChaseUIDRequest;
  orderCount: number;
  tax: any;
  isCreateNewProfileDisabled: boolean;
  isProfileSubmitDisabled: boolean;

  selectedProfile: any;

  profileTransType: string;
  agencycomm: any;
  taxtmp: any;
  paymenttype: string;

  ShowACH: boolean;
  ShowCC: boolean;

  //Ajay - Button Disable
  isLoading: boolean = true;

  history: TransactionHistory[];

  constructor(private externalUserService: ExternalUserService, private route: ActivatedRoute,
    private _location: Location, private router: Router) {
    this.Ordertotalamount = 0;
    this.selectedOrderIDs = '';
    this.isPayment = true;
    this.displayAddRefundPopUp = false;
    this.ShowACH = false;
    this.ShowCC = false;
    this.isChecked = true;
  }

  ngOnInit() {

    this.ShowACH = true;
    this.ShowCC = false;
    this.sub = this.route.params.subscribe(params => {
      this.chaseOrderId = params['chaseOrderId'];
      // debugger;
      this.externalUserService.getTransactionHistory(this.chaseOrderId)
        .subscribe(
          (p) => {
            // debugger;
            //let history: TransactionHistory[];
           this.history = p;
            this.orderCount = this.history.length;
            this.taxtmp = 0;
            this.tax = 0;
            for (let hist of this.history) {
              this.Ordertotalamount += hist.totalAmount;
              this.selectedOrderIDs = this.selectedOrderIDs + hist.orderId + ', ';
              if (hist.tax > 0) {
                this.taxtmp = hist.tax;
              }
            }

            this.actualAmount = this.Ordertotalamount;
            this.selectedOrderIDs = this.selectedOrderIDs.substr(0, this.selectedOrderIDs.length - 2);
            this.OrderagencyID = this.history[0].agencyId.toString();
            this.agencycomm = this.history[0].agencyComm;
            this.tax = this.taxtmp;
          // to load page after user comes back from payment page
          if (this.history[0].isPartialPayment == true && this.history[0].transactionAmount != null) {
            //debugger;
            this.paymenttype = "Partial";
            this.Ordertotalamount = this.history[0].partialAmount;
            this.isChecked = false;
            this.isPayment = false;
          }
          else {
            this.paymenttype = "Full";            
            this.isChecked = true;
            this.isPayment = true;
          }
            this.externalUserService.GetOrderDiscountDetail(this.Ordertotalamount, this.OrderagencyID, this.tax, this.agencycomm, this.paymenttype,this.selectedOrderIDs).subscribe(
              (q) => {
                //Ajay - Button Disable
                this.isLoading = false;

              // debugger;

              this.orderDetail = q;

              this.AmountpayingACH = q['ordTotalNetDiscountACH'].toString().replace(/,/g, '');
              this.AmountpayingCC = q['ordTotalNetDiscountCC'].toString().replace(/,/g, '');

            }
          );


          if (this.orderCount > 1) {

            this.isSelectedMultipleOrder = true;
          } else {
            this.isSelectedMultipleOrder = false;
          }
        }
        );


    });

    this.InvalidAmount = false;
    this.InvalidAmount2 = false;

    // debugger;


    this.UserID = sessionStorage.getItem('userid');

  }
  GetOrderDetails() {
    this.OrderagencyID = sessionStorage.getItem('AgencyID');
    //Ajay - Button Disable
    this.isLoading = true;
    this.externalUserService.GetOrderDiscountDetail(this.Ordertotalamount, this.OrderagencyID, this.tax, this.agencycomm, this.paymenttype, this.selectedOrderIDs).subscribe(
      p => {
        //Ajay - Button Disable
        this.isLoading = false;

        this.orderDetail = p;
        this.AmountpayingACH = p['ordTotalNetDiscountACH'].toString().replace(/,/g, '');
        this.AmountpayingCC = p['ordTotalNetDiscountCC'].toString().replace(/,/g, '');

      },
    );
  }

  reCalculate(event, OrderagencyID, paymenttype) {

    this.InvalidAmount = false;
    this.InvalidAmount2 = false;


    if (Number(this.Ordertotalamount) >= this.actualAmount && this.isChecked === false) {
      this.InvalidAmount = true;
    } else if (Number(this.Ordertotalamount) <= 0) {
      this.InvalidAmount2 = true;
    } else {
      //Ajay - Button Disable
      this.isLoading = true;

      this.externalUserService.GetOrderDiscountDetail(this.Ordertotalamount, this.OrderagencyID, this.tax, this.agencycomm, this.paymenttype,this.selectedOrderIDs).subscribe(
        p => {
          //Ajay - Button Disable
          this.isLoading = false;

          this.orderDetail = p;
          this.AmountpayingACH = p['ordTotalNetDiscountACH'].toString().replace(/,/g, '');
          this.AmountpayingCC = p['ordTotalNetDiscountCC'].toString().replace(/,/g, '');
        },
      );
    }
  }

  onChecked(event) {

    if (event.target.checked === false) {
      this.isChecked = false;
      this.isPayment = false;
      this.InvalidAmount = false;
      this.paymenttype = "Partial";
    } else {
      this.isChecked = true;
      this.isPayment = true;
      this.Ordertotalamount = this.actualAmount;
      this.paymenttype = "Full";
      this.reCalculate(this.Ordertotalamount, this.OrderagencyID, this.paymenttype);
      if (this.actualAmount >= +this.Ordertotalamount) {
        this.InvalidAmount = false;
      }
    }
  }
  // Method to go back
  goback() {
    this.router.navigate(['Invoice', 'order']);
  }

  Paynowprofile(value: any) {

    let requestData = new TransactionHistoryUpdate();
    requestData.chaseOrderId = this.chaseOrderId;
// Arvind for caputring ACH and CC net amount
   requestData.ordTotalNetDiscountACH = this.AmountpayingACH;
   requestData.ordTotalNetDiscountCC = this.AmountpayingCC;

    if (this.paymenttype === "Partial") {
      requestData.isPartialPayment = true;
      requestData.partialAmount = this.Ordertotalamount.toString();
    }
    else {
      requestData.isPartialPayment = false;
      // requestData.partialAmount = this.Ordertotalamount.toString();
    }

    if (value === 1) {
      this.profileTransType = 'ACH';
      requestData.transactionAmount = this.AmountpayingACH;
    } else if (value === 2) {
      this.profileTransType = 'CC';
      requestData.transactionAmount = this.AmountpayingCC;
    }

    this.externalUserService.updateTransactionHistory(requestData).subscribe(
      response => {
        let status = response;

        if (status === 'Success') {
          this.router.navigate(['MediaPayPayment', 'Order', this.profileTransType, this.chaseOrderId]);
        }
      });

  }

  onRadioACHChecked(event) {    
    if (event.target.checked == true) {
      this.ShowACH = true;
      this.ShowCC = false;

    }
  }

  onRadioCCChecked(event) {    
    if (event.target.checked == true) {
      this.ShowCC = true;
      this.ShowACH = false;

    }
  }
}



// WEBPACK FOOTER //
// ./src/app/external-user/order-details/order-details.component.ts